import styled from '@emotion/styled';

export const DateInputWrapper = styled('div', { label: 'DateInputWrapper' })`
    padding-top: 40px;
`;
